export const CODE_BLOCK_LANGUAGES = {
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    jsx: 'JSX',
    tsx: 'TSX',
    html: 'HTML',
    css: 'CSS',
    sql: 'SQL',
    python: 'Python',
    rust: 'Rust',
    xml: 'XML',
    json: 'JSON',
    markdown: 'Markdown',
    java: 'Java',
    c: 'C',
    cpp: 'C++',
    csharp: 'C#',
    fsharp: 'F#',
    lezer: 'Lezer',
    php: 'PHP',
    wast: 'WAST',
    apl: 'apl',
    asciiarmor: 'asciiarmor',
    asn1: 'asn1',
    asterisk: 'asterisk',
    brainfuck: 'brainfuck',
    clike: 'clike',
    objectiveC: 'Objective-C',
    kotlin: 'Kotlin',
    clojure: 'Clojure',
    cmake: 'CMake',
    cobol: 'COBOL',
    coffeescript: 'coffeescript',
    commonlisp: 'Common Lisp',
    crystal: 'crystal',
    cypher: 'cypher',
    d: 'd',
    diff: 'diff',
    dockerfile: 'Dockerfile',
    dtd: 'dtd',
    dylan: 'dylan',
    ebnf: 'ebnf',
    ecl: 'ecl',
    eiffel: 'eiffel',
    elm: 'elm',
    factor: 'factor',
    fcl: 'fcl',
    forth: 'forth',
    gas: 'gas',
    gherkin: 'gherkin',
    go: 'Go',
    haskell: 'Haskell',
    haxe: 'haxe',
    http: 'http',
    idl: 'idl',
    jinja2: 'jinja2',
    julia: 'Julia',
    livescript: 'livescript',
    lua: 'Lua',
    mathematica: 'mathematica',
    mbox: 'MBOX',
    mirc: 'mirc',
    mllike: 'mllike',
    modelica: 'modelica',
    mscgen: 'mscgen',
    mumps: 'mumps',
    nginx: 'nginx',
    nsis: 'nsis',
    ntriples: 'ntriples',
    octave: 'Octave',
    oz: 'oz',
    pascal: 'Pascal',
    perl: 'Perl',
    pig: 'pig',
    powershell: 'PowerShell',
    properties: 'properties',
    protobuf: 'Protobuf',
    puppet: 'puppet',
    q: 'q',
    r: 'R',
    rpm: 'rpm',
    ruby: 'Ruby',
    sas: 'sas',
    scheme: 'Scheme',
    shell: 'Shell',
    smalltalk: 'smalltalk',
    solr: 'solr',
    sparql: 'sparql',
    spreadsheet: 'spreadsheet',
    stex: 'STEX',
    stylus: 'stylus',
    swift: 'Swift',
    tcl: 'tcl',
    textile: 'textile',
    tiddlywiki: 'tiddlywiki',
    tiki: 'tiki',
    toml: 'toml',
    troff: 'troff',
    ttcn: 'ttcn',
    turtle: 'turtle',
    vb: 'vb',
    vbscript: 'vbscript',
    velocity: 'velocity',
    verilog: 'Verilog',
    vhdl: 'VHDL',
    webidl: 'webidl',
    xquery: 'xquery',
    yacas: 'yacas',
    yaml: 'YAML',
    z80: 'z80',
    solidity: 'Solidity',
    erlang: 'Erlang',
    groovy: 'Groovy',
    js: 'JavaScript',
    sass: 'SASS',
    scala: 'Scala',
    ts: 'Typescript',
    excel: 'Excel',
    bash: 'Bash',
    dart: 'Dart',
    matlab: 'MatLab',
    elixir: 'Elixir',
    txt: 'Text',
    objectivec: 'Objective-C',
    objc: 'Objective-C',
    asm: 'Assembly (x86)',
    sh: 'Shell',
    fortran: 'Fortran',
    vbnet: 'VB.NET',
    ada: 'Ada',
    prolog: 'Prolog',
    lisp: 'Common Lisp',
    ocaml: 'OCaml',
    nim: 'Nim',
}

export const REQUEST_FILE_TYPES = [
    'doc',
    'docx',
    'txt',
    'pdf',
    'pptx',
    'xlsx',
    'jpeg',
    'png',
    'webp',
    'bmp',
    'jpg',
    'ppt',
    'xls',
]

export const MODEL_ALIAS_LIST = {
    ['TEXT']: [
        {
            title: 'Лучшая модель для текста',
            description: 'Максимально доступное качество результата',
            slug: 'BEST_TEXT',
            model_type: 'TEXT',
        },
        {
            title: 'Оптимальная модель для текста',
            description: 'Оптимальный режим, качество результата ≥ 70%',
            slug: 'OPTIMAL_TEXT',
            model_type: 'TEXT',
        },
    ],
    ['IMAGE']: [
        {
            title: 'Лучшая модель для изображений',
            description: 'Максимально доступное качество результата',
            slug: 'BEST_IMAGE',
            model_type: 'IMAGE',
        },
        {
            title: 'Оптимальная модель для изображений',
            description: 'Оптимальный режим, качество результата ≥ 70%',
            slug: 'OPTIMAL_IMAGE',
            model_type: 'IMAGE',
        },
    ],
    ['VIDEO']: [
        {
            title: 'Лучшая модель для видео',
            description: 'Максимально доступное качество результата',
            slug: 'BEST_VIDEO',
            model_type: 'VIDEO',
        },
        {
            title: 'Оптимальная модель для видео',
            description: 'Оптимальный режим, качество результата ≥ 70%',
            slug: 'OPTIMAL_VIDEO',
            model_type: 'VIDEO',
        },
    ],
    ['SPEECH']: [
        {
            title: 'Лучшая модель для речи',
            description: 'Максимально доступное качество результата',
            slug: 'BEST_SPEECH',
            model_type: 'SPEECH',
        },

        {
            title: 'Оптимальная модель для речи',
            description: 'Оптимальный режим, качество результата ≥ 70%',
            slug: 'OPTIMAL_SPEECH',
            model_type: 'SPEECH',
        },
    ],
}

export const FREE_MODEL_LIST = [
    {
        name: 'OpenAI: O4 Mini',
        key: 'OPENAI_O4_MINI',
    },
    {
        name: 'Deepseek: R1 0528 Qwen3 8B',
        key: 'DEEPSEEK_R1_QWEN_3_8B',
    },
    {
        name: 'Gemini: Flash 1.5 8B',
        key: 'GEMINI_FLASH_1.5_8B',
    },
]

export const FREE_MODEL_BY_DEFAULT = 'OPENAI_O4_MINI'
